import React from "react";
import { LoadingPopup, B2BSpinner, PoweredByHopper } from "halifax";
import { BookingInProgressModalConnectorProps } from "./container";
import "./styles.scss";
import { useEffect } from "react";
import { VIEWED_CAR_BOOK_PROCESSING } from "redmond";
import dayjs from "dayjs";
import { trackEvent } from "../../../../api/v1/analytics/trackEvent";

export interface IBookingInProgressModalProps
  extends BookingInProgressModalConnectorProps {}

export const BookingInProgressModal = ({
  inProgress,
  priceQuoteInProgress,
  car,
}: IBookingInProgressModalProps) => {
  const startTime = dayjs();
  useEffect(() => {
    if (!inProgress && car) {
      trackEvent({
        eventName: VIEWED_CAR_BOOK_PROCESSING,
        properties: {
          runtime: dayjs().diff(startTime, "seconds", true),
        },
      });
    }
  }, [inProgress, car]);

  return (
    <LoadingPopup
      indicatorSize={"small"}
      indicator={B2BSpinner}
      open={inProgress || priceQuoteInProgress}
      popupSize={"small"}
      message={
        priceQuoteInProgress
          ? "Saving driver and checking availability"
          : "Booking your car"
      }
      footer={PoweredByHopper}
    />
  );
};
